import { render, staticRenderFns } from "./quote-detail.vue?vue&type=template&id=74f40062"
import script from "./quote-detail.vue?vue&type=script&lang=js"
export * from "./quote-detail.vue?vue&type=script&lang=js"
import style0 from "./quote-detail.vue?vue&type=style&index=0&id=74f40062&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports